import * as React from "react";

export function hasChildren(element) {
  return React.isValidElement(element) && Boolean(element.props.children);
}

export function childToString(child) {
  if (
    typeof child === "undefined" ||
    child === null ||
    typeof child === "boolean"
  ) {
    return "";
  }

  if (typeof child === "object") {
    return "";
  }

  return child.toString();
}

export function onlyText(children) {
  if (!(children instanceof Array) && !React.isValidElement(children)) {
    return childToString(children);
  }

  return React.Children.toArray(children).reduce((text, child) => {
    let newText;

    if (React.isValidElement(child) && hasChildren(child)) {
      newText = onlyText(child.props.children);
    } else {
      newText = childToString(child);
    }

    return text.concat(newText);
  }, "");
}
